import { render, staticRenderFns } from "./thicknesselement.vue?vue&type=template&id=afc5f7de&"
import script from "./../../ts/articleattributes/thicknesselement.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/thicknesselement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports